import { notificationsSlice } from 'features/notifications/notificationsSlice';
import { SnackBar } from 'uikit';
import type { SnackBarItemDefault } from 'uikit';

import React, { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { getNotificationItems } from '../../app/selectors';

import styles from './Notification.module.css';

export const Notifications = () => {
    const dispatch = useDispatch();
    const items = useSelector(getNotificationItems);

    const handleItemOnClose = useCallback(
        (item) => {
            dispatch(notificationsSlice.actions.remove(item.key));
        },
        [dispatch],
    );

    const getItemAutoCloseTimeout = useCallback((item: SnackBarItemDefault) => item.autoClose || 5, []);

    const getItemShowProgress = useCallback((item: SnackBarItemDefault) => item.showProgress || 'line', []);

    const getItemActions = useCallback((item: SnackBarItemDefault) => {
        if (Array.isArray(item.actions)) {
            return item.actions.map((button) => ({
                label: button.label,
                onClick: button.onClick,
            }));
        }

        return undefined;
    }, []);

    return (
        <SnackBar
            className={styles.notifications}
            items={items}
            onItemClose={handleItemOnClose}
            onItemAutoClose={handleItemOnClose}
            getItemAutoClose={getItemAutoCloseTimeout}
            getItemShowProgress={getItemShowProgress}
            getItemActions={getItemActions}
        />
    );
};

Notifications.displayName = 'Notifications';
